import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { BookingDialog } from '../components/BookingDialog.tsx';
import { useRooms } from '../queries.ts';
import { addMinutes, roundQuarter } from '../time.ts';
import { isStaff, type Me } from '../types.ts';

export function RoomsPage({ me }: { me: Me }) {
  const { t } = useTranslation();
  const rooms = useRooms();
  const [booking, setBooking] = useState<string | null>(null);
  const list = rooms.data ?? [];
  const floors = [...new Set(list.map((r) => r.floor))].sort((a, b) => a - b);
  const start = roundQuarter(addMinutes(new Date(), 15));

  return (
    <>
      {floors.map((f) => (
        <section key={f} aria-labelledby={`floor-${f}`}>
          <h2 id={`floor-${f}`} style={{ margin: '10px 0' }}>
            {t('common.floor')} {f}
          </h2>
          <div className="rooms">
            {list
              .filter((r) => r.floor === f)
              .map((r) => (
                <article className="card" key={r.id}>
                  <div className="ph">
                    {r.photoIds[0] ? (
                      <img
                        src={`/api/rooms/${r.id}/photos/${r.photoIds[0]}?size=card`}
                        alt=""
                        loading="lazy"
                      />
                    ) : (
                      t('rooms.noPhoto')
                    )}
                  </div>
                  <h3>
                    {r.name}{' '}
                    <span className="pill">
                      {r.capacity} {t('common.people')}
                    </span>{' '}
                    {!r.canBook && <span className="pill warn">{t('rooms.inactive')}</span>}
                  </h3>
                  {r.equipment && (
                    <p className="k">
                      {t('rooms.equipment')}: {r.equipment}
                    </p>
                  )}
                  {r.layout && (
                    <p className="k">
                      {t('rooms.layout')}: {r.layout}
                    </p>
                  )}
                  {r.description && <p>{r.description}</p>}
                  <div className="actions">
                    {r.canBook && (
                      <button className="btn sm" onClick={() => setBooking(r.id)}>
                        {t('rooms.book')}
                      </button>
                    )}
                    {isStaff(me) && (
                      <>
                        <Link className="btn alt sm" to={`/admin/rooms?edit=${r.id}`}>
                          {t('common.edit')}
                        </Link>
                        <Link className="btn alt sm" to={`/admin/rooms/${r.id}/sign`}>
                          {t('rooms.qr')}
                        </Link>
                      </>
                    )}
                  </div>
                </article>
              ))}
          </div>
        </section>
      ))}
      {booking && (
        <BookingDialog
          me={me}
          rooms={list}
          initial={{ roomId: booking, start, end: addMinutes(start, 60) }}
          onClose={() => setBooking(null)}
        />
      )}
    </>
  );
}
